import { useState, React, useContext, useEffect } from "react";
import { AccountContext } from "../../components/Account";
import { CallBackend } from "../../utils/apiCall";
import Form from "../../components/classification-components/Form";

const ClassificationManager = () => {
  const { refreshUser } = useContext(AccountContext);

  const [data, setData] = useState(null);
  const [submittedAssessor, setSubmittedAssessor] = useState(false);

  const [error, setError] = useState(null);

  async function getData() {
    await refreshUser().then((result) => {
      CallBackend({}, `params`, "GET", result)
        .then((response) => {
          setData(response);
        })
        .catch((err) => {
          setError(err);
        });
    });
  }

  useEffect(() => {
    getData();
  }, [submittedAssessor]);

  return (
    <div className="page_wrapper">
      {error && (
        <div className="regionArea">
          <div className="assetHeader">
            <h1>Error getting parameter data.</h1>
          </div>
          <div className="regionBody">
            <p>
              There was an error getting the parameter data. Please try again.
            </p>
          </div>
        </div>
      )}

      <div className="regionArea">
        <div className="assetHeader">
          <h1>Classification Manager</h1>
        </div>
        <div className="regionBody">
          {data ? (
            <Form
              setSubmittedAssessor={setSubmittedAssessor}
              submittedAssessor={submittedAssessor}
              data={data}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default ClassificationManager;
